import axios from "axios";
import CryptoJS from "crypto-js";
import store from "@/store";
import router from "@/router";
import { Dialog } from "vant";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000,
});

service.interceptors.request.use(
  (config) => {
    // 检查请求 URL 是否为特定的请求
    // if (config.url !== "/getTokenCode") {
    //   const kNetMD5Key = "CF3A561F-398C-4E01-8C33-A6774F4B444B";
    //   const randomNum =
    //     Math.floor(Math.random() * (9999999999999999 - 1000000000000000 + 1)) +
    //     1000000000000000;
    //   const timestamp = Date.now() / 1000;
    //   const originalString = kNetMD5Key + randomNum + timestamp;
    //   const firstHasStr = CryptoJS.MD5(originalString).toString(
    //     CryptoJS.enc.Hex
    //   );
    //   const hashString = CryptoJS.MD5(firstHasStr).toString(CryptoJS.enc.Hex);
    //   config.headers["Sign-Verify"] = hashString;
    //   config.headers["Sign-Noncestr"] = randomNum;
    //   config.headers["Sign-Timestamp"] = timestamp;
      let token = store.getters.token || sessionStorage.getItem("token");
    //   config.headers["token"] = token;
      config.headers["YJS-TOKEN"] = 'Bearer ' + token;
    // }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
service.interceptors.response.use(
  (res) => {
    // if (res.data.code !== 0) {
    //   router.push({ name: "downgrade" });
    // }
    if(res.data.msg === 'token 无效：null') {
      Dialog.alert({
        message: '账户信息加载异常，请退出应用后重新进入',
        closeOnPopstate: false,
        showConfirmButton: false
      });
    }
    return res.data;
  },
  (err) => {
    router.push({ name: "downgrade" });
    return Promise.reject(err);
  }
);

export default service;
